import {useContext} from 'react';
import {UserContext} from 'contexts/user';

export default function useUser() {
  const value = useContext(UserContext);
  return value;
}
